import * as React from 'react';
const SvgIcon = props => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M320-253.85 93.85-480 320-706.15l42.77 42.77-184 184L362.15-296zm320 0-42.77-42.77 184-184L597.85-664 640-706.15 866.15-480z"></path>
    </svg>;
};
export default React.memo(SvgIcon);